import React, { useRef, useState } from "react";
import heroImg from "../assets/heroImg.svg";
import tofLogo from "../assets/tofLogo.svg";
import encLinks from "../assets/encLinks.png";
import { Link } from "react-router-dom";

const Home = () => {
  const logos = [tofLogo, encLinks];
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(true);

  const handlePlayPause = () => {
    if (!videoRef.current) return;
    if (isPlaying) {
      videoRef.current.pause();
    } else {
      videoRef.current.play();
    }
    setIsPlaying(!isPlaying);
  };
  const handleGetStarted = () => {
  // Example: navigate to register page
  window.location.href = "/register";
};

  return (
    <div className="flex flex-col">
      <div className="flex justify-between gap-6 w-full  xsm:flex-col items-center">
        <div className="w-1/2 xsm:w-full flex gap-6 flex-col">
         <div className="flex items-center border rounded-full px-4 py-2 space-x-4 shadow-sm bg-white justify-between">
            {/* Left section with blinking live dot and text */}
              <div className="flex flex-1 items-center border rounded-xl px-3 py-1">
                {/* Three-layer, small, blinking live dot */}
                <span className="h-3 w-3 mr-2 relative flex items-center justify-center">
                  {/* Outer pulsing ring */}
                  <span className="absolute inset-0 rounded-full bg-green-400 opacity-40 animate-ping"></span>
                  {/* Middle ring */}
                  <span className="absolute inset-1 rounded-full bg-green-500 opacity-70 animate-pulse"></span>
                  {/* Core dot */}
                  <span className="relative h-1.5 w-1.5 bg-green-600 rounded-full z-10"></span>
                </span>
                <span className="text-gray-800 font-medium">
                  Opportunities
                </span>
              </div>
            {/* Right section with call to action */}
            <div className="flex items-center space-x-2">
              <span className="text-gray-800 ">Sign up Now!</span>
              <span className="text-gray-800">→</span>
            </div>
          </div>
          {/* Main Heading */}
<div className="space-y-6">
  <h1 className="text-5xl lg:text-5xl md:text-4xl sm:text-3xl font-bold bg-gradient-to-r from-gray-900 via-green-700 to-yellow-500 bg-clip-text text-transparent leading-tight">
    Your Gateway to Exciting 
    <br />
    <span className="text-transparent bg-gradient-to-r from-green-500 via-yellow-400 to-yellow-600 bg-clip-text">
       Opportunities!
    </span>
  </h1>
  
  <p className="text-xl text-gray-600 leading-relaxed max-w-lg">
    Connecting ambitious students and graduates with industry-leading companies for meaningful career growth and professional development.
  </p>
</div>

{/* CTA Button */}
<button 
  onClick={handleGetStarted}
  className="inline-flex items-center justify-center px-6 py-3 bg-green-600 hover:bg-green-700 text-white font-medium rounded-xl shadow-sm transition-all duration-200 w-fit group"
>
  Get Started
  <span className="ml-2 group-hover:translate-x-1 transition-transform">→</span>
</button>
</div>
        <span className="w-1/2 xsm:w-full relative flex flex-col items-end">
          <video
            ref={videoRef}
            src="https://ucarecdn.com/720b62ed-2e1f-4b7f-a459-6ed1013c4ec1/"
            // src="https://ucarecdn.com/4873e529-4153-4266-8192-60c5ad026de0/"
            className="w-full object-cover rounded-lg shadow-md"
            autoPlay
            loop
            muted={false}  
            playsInline
          />
          <button
            onClick={handlePlayPause}
            className="absolute bottom-4 right-4 bg-white/80 hover:bg-white text-gray-800 px-3 py-1 rounded shadow transition"
          >
            {isPlaying ? "Pause" : "Play"}
          </button>
        </span>
        {/* <span className="w-1/2 xsm:w-full ">
          <img src={heroImg} alt="" className="w-full object-cover" />
        </span> */}
      </div>
<div className="bg-gray-50 rounded-2xl py-8 px-6 border border-gray-100 my-8">
  <div className="text-center mb-6">
    <span className="text-sm font-medium text-gray-600 tracking-wide">
      Proudly Sponsored By
    </span>
  </div>
  <div className="flex flex-wrap gap-8 lg:gap-16 items-center justify-center">
    {/* Ennclinks */}
    <a
      href="https://www.enclinks.com"
      target="_blank"
      rel="noopener noreferrer"
      className="bg-white rounded-xl shadow-sm border border-gray-50 p-4 flex items-center justify-center hover:shadow-md transition-all duration-200"
    >
      <img
        src={encLinks}
        alt="Ennclinks Sponsor Logo"
        className="w-24 h-12 object-contain opacity-80 hover:opacity-100 transition-opacity"
      />
    </a>
    {/* The Oyekunle Foundation */}
    <a
      href="https://www.theoyekunlefoundation.org"
      target="_blank"
      rel="noopener noreferrer"
      className="bg-white rounded-xl shadow-sm border border-gray-50 p-4 flex items-center justify-center hover:shadow-md transition-all duration-200"
    >
      <img
        src={tofLogo}
        alt="The Oyekunle Foundation Sponsor Logo"
        className="w-24 h-12 object-contain opacity-80 hover:opacity-100 transition-opacity"
      />
    </a>
  </div>
</div>
    </div>
  );
};

export default Home;